import { ElementRef } from '@angular/core';
import { MediaQuery } from 'core/src/app/ui/common/services/media-query.service';

// /**
//  * Allows a component to become dynmanically stylable via code (as opposed to simply adding attributes via HTML)
//  */
export abstract class StylableComponent {
  constructor(protected _el: ElementRef,  readonly _mediaQuery: MediaQuery) { }
}
